import { Dispatch } from 'redux';
import { IVehicle } from 'components/SearchBlock/CarSearch/CarSearchBlock';
import { SELECTED_VEHICLE_STORAGE_KEY, SET_SELECTED_VEHICLE } from 'data/selectedVehicle/selectedVehicleReducer';

export function setSelectedVehicleInStore(payload?: IVehicle) {
    return (dispatch: Dispatch) => {
        try {
            if (payload) {
                sessionStorage.setItem(SELECTED_VEHICLE_STORAGE_KEY, JSON.stringify(payload));
            } else {
                sessionStorage.removeItem(SELECTED_VEHICLE_STORAGE_KEY);
            }
        } catch (e) {}

        return dispatch({
            type: SET_SELECTED_VEHICLE,
            payload,
        });
    };
}
